module.exports = __webpack_public_path__ + "img/Classic Series 52-Quart Hard Cooler.303eff2b.jpg";